const FormStepTypes = {
  ORGANISATION: "organisation",
  SCHEDULE: "schedule",
  PACKING_LIST: "packing-list",
  SERVICE: "service",
  PROVIDER: "provider",
  CONFIRMATION: "confirmation",
  SHIPMENT: "shipment",
  QUOTATION: "quotation",
};

export default FormStepTypes;
